var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeakerphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    stroke: "#05112E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "speakerphone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 6.66695C15.663 6.66695 16.2989 6.93035 16.7678 7.39919C17.2366 7.86803 17.5 8.50391 17.5 9.16695C17.5 9.82999 17.2366 10.4659 16.7678 10.9347C16.2989 11.4036 15.663 11.667 15 11.667M8.33333 6.66695V15.8336C8.33333 16.0546 8.24554 16.2666 8.08926 16.4229C7.93298 16.5792 7.72101 16.667 7.5 16.667H6.66667C6.44565 16.667 6.23369 16.5792 6.07741 16.4229C5.92113 16.2666 5.83333 16.0546 5.83333 15.8336V11.667M10 6.66695L13.77 3.52528C13.8795 3.43404 14.0128 3.37591 14.1542 3.3577C14.2956 3.3395 14.4393 3.36197 14.5684 3.42249C14.6975 3.48301 14.8066 3.57907 14.8831 3.69941C14.9595 3.81975 15.0001 3.95938 15 4.10195V14.2319C15.0001 14.3745 14.9595 14.5142 14.8831 14.6345C14.8066 14.7548 14.6975 14.8509 14.5684 14.9114C14.4393 14.9719 14.2956 14.9944 14.1542 14.9762C14.0128 14.958 13.8795 14.8999 13.77 14.8086L10 11.6669H3.33333C3.11232 11.6669 2.90036 11.5792 2.74408 11.4229C2.5878 11.2666 2.5 11.0546 2.5 10.8336V7.50028C2.5 7.27927 2.5878 7.06731 2.74408 6.91103C2.90036 6.75475 3.11232 6.66695 3.33333 6.66695H10Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerphone);
export default __webpack_public_path__ + "static/media/speakerphone.02be35d11a85668b2e6c05c379fa3729.svg";
export { ForwardRef as ReactComponent };